import { Badge, BadgeProps, styled } from '@material-ui/core';

export const StyledBadge = styled(Badge)<BadgeProps>(() => ({
    '& .MuiBadge-badge': {
        right: 25,
        padding: '8px',
        whiteSpace: 'nowrap',
    },
}));
